import React from 'react';
import { useLocation } from 'react-router-dom';
import { SkeletonHeader } from '../Header/skeleton/SkeletonHeader';
import { SkeletonNavigation } from '../Header/skeleton/SkeletonNavigation';
import { RecoverAccountSkeleton } from '../RecoverAccount/RecoverAccountSkeleton';
import { SkeletonCard } from '../Header/skeleton/SkeletonCard';

export function RouteSkeleton(): React.ReactElement {
  const location = useLocation();
  
  // 🔐 AUTH ROUTES - Usar RecoverAccountSkeleton
  if (location.pathname === '/recoveraccount') {
    return <RecoverAccountSkeleton />;
  }
  
  if (location.pathname === '/resetpassword') {
    return <RecoverAccountSkeleton />;
  }
 
  // 🏠 HOME - Usar SkeletonHeader
  if (location.pathname.includes('/home')) {
    return <SkeletonHeader />;
  }

  // 🧩 MODULES - Usar SkeletonHeader  
  if (location.pathname.includes('/modules')) {
    return <SkeletonHeader />;
  }

  // 🏢 ACCOUNT ROUTES - Usar skeletons específicos
  
  // Account management page (debe ir antes que accounts genérico)
  if (location.pathname.includes('/accounts/') && location.pathname.includes('/accounts/management')) {
    return <SkeletonCard />;
  }

  // Account new page (debe ir antes que accounts genérico)
  if (location.pathname.includes('/accounts/') && location.pathname.includes('/accounts/new')) {
    return <SkeletonCard />;
  }

  // Account list page
  if (location.pathname.includes('/accounts/') && location.pathname.match(/\/accounts\/?$/)) {
    return <SkeletonCard />;
  }

  // Account root page with ID (debe ir después de las rutas específicas)
  if (location.pathname.match(/\/accounts\/[^/]+\/?$/)) {
    return <SkeletonHeader />;
  }

  // 🤖 ASSISTANTS - Rutas específicas con SkeletonNavigation
  if (location.pathname.includes('/accounts/') && location.pathname.includes('/assistants')) {
    // Rutas específicas que usan SkeletonNavigation
    if (location.pathname.includes('/inbox') ||
        location.pathname.includes('/myassistant/flows') || 
        location.pathname.includes('/myassistant/process') ||
        location.pathname.includes('/myassistant/knowledge') ||
        location.pathname.includes('/myassistant/channels') ||
        location.pathname.includes('/myassistant/queues') ||
        location.pathname.includes('/myassistant/appearance') ||
        location.pathname.includes('/myassistant/personality') ||
        location.pathname.includes('/myassistant/metrics') ||
        location.pathname.includes('/myassistant/team-overview') ||
        location.pathname.includes('/metrics') ||
        location.pathname.includes('/access-verification')) {
      return <SkeletonNavigation />;
    }
    
    // Todas las demás rutas de assistants usan SkeletonCard
    return <SkeletonCard />;
  }
  
  // ⚙️ SETTINGS - Usar SettingsSkeleton
  if (location.pathname.includes('/accounts/') && location.pathname.includes('/settings')) {
    return <SkeletonNavigation />;
  }

  // 📊 METRICS - Usar SkeletonNavigation
  if (location.pathname.includes('/accounts/') && location.pathname.includes('/metrics')) {
    return <SkeletonHeader />;
  }
  
  // 🔧 DEFAULT - Usar SkeletonNavigation para todas las demás rutas
  return <SkeletonNavigation />;
}